// extracted by mini-css-extract-plugin
export default {"container":"j9X57yhIl537wmM9Xi0W","bigCard":"GYvSWn7OIeICb4zo5bzf","header":"N7QHdwwAnEGoYLy34ek1"};